import { CommunityEngagementPictogram } from '@r-client/dls/ui/pictograms';
import { OnchainInfraPictogram } from '@r-client/dls/ui/pictograms';
import { RaiseCapitalPictogram } from '@r-client/dls/ui/pictograms';
import { RwaTokenizationPictogram } from '@r-client/dls/ui/pictograms';
import { Web3AdvisoryPictogram } from '@r-client/dls/ui/pictograms';

import { IService } from './types';

export const SERVICES: IService[] = [
  {
    name: 'Raise capital',
    icon: RaiseCapitalPictogram,
    items: [
      {
        name: 'Early stage',
        description: 'Funding for growth',
        href: '/raise',
      },
      {
        name: 'Community raise',
        description: 'Activate your community’s support',
        href: '/raise',
      },
    ],
  },
  {
    name: 'Community engagement',
    icon: CommunityEngagementPictogram,
    items: [
      {
        name: 'Token launchpad',
        description: 'Market entry for creators and investors',
        href: '/launchpad',
      },
      {
        name: 'Equity sharedrops™',
        description: 'Reward your community with shares',
        href: '/sharedrops',
      },
    ],
  },
  {
    name: 'RWA tokenization',
    icon: RwaTokenizationPictogram,
    items: [
      {
        name: 'Institutional funds',
        description: 'Open access to all levels of investor',
        href: '/tokenization',
      },
      {
        name: 'Debt',
        description: 'Leverage worldwide networks for funding',
        href: '/tokenization',
      },
      {
        name: 'Equity',
        description: 'Transform securities into accessible investments',
        href: '/tokenization',
      },
      {
        name: 'Commodities',
        description: 'Democratize access for easier trading',
        href: '/tokenization',
      },
    ],
  },
  {
    name: 'On-chain infrastructure',
    icon: OnchainInfraPictogram,
    items: [
      {
        name: 'Infrastructure',
        description:
          'Test- and main-net support, validator tooling, RPC infrastructure',
        href: '/infrastructure',
      },
      {
        name: 'Wallet-as-a-service',
        description: 'Multiple blockchains accessible on your platform',
        href: '/infrastructure',
      },
      {
        name: 'Staking',
        description:
          'PoS staking, white label validators, on demand staking integrations',
        href: '/infrastructure',
      },
      {
        name: 'Foundation support',
        description: 'Network tooling, validator monitoring and alerting',
        href: '/infrastructure',
      },
    ],
  },
  {
    name: 'Advisory & research',
    icon: Web3AdvisoryPictogram,
    items: [
      {
        name: 'Token design',
        description: 'Align strategy, goals, and technology',
        href: '/advisory',
      },
      {
        name: 'Token management',
        description:
          'Distributions, vesting, and reporting all in one platform.',
        href: '/advisory',
      },
      {
        name: 'Tokenization',
        description: 'Turn assets into blockchain ready tokens',
        href: '/advisory',
      },
      {
        name: 'Business development',
        description: 'Strategic guidance to bring your project to market',
        href: '/advisory',
      },
      {
        name: 'Security tokenization',
        description: 'Open value within regulatory frameworks',
        href: '/advisory',
      },
      {
        name: 'NFT Strategy',
        description: 'From token design to market launch',
        href: '/advisory',
      },
      {
        name: 'Token offerings',
        description: 'Allow users to own a piece of the network',
        href: '/advisory',
      },
      {
        name: 'Growth + Marketing',
        description: 'Expand your token’s profile',
        href: '/advisory',
      },
    ],
  },
];
